module.exports = __webpack_public_path__ + "static/media/climate_water_2_watershedsStress.f14f1476.jpg";